export const tourText = [
    {
      id:1,
      text: "I am the owner of the company and I use Everhour for timekeeping of myself and my subcontractors. All team members use the system - from web developers to tech support to project management to design.",
      name: "— Jennifer H.",
    },
    {
      id:2,
      text: "“Everhour is being used by my department now, but it’s planned to be used across the whole company. We were having problems tracking the times of every project and Everhour ended up being the best solution to the issue. We’re tracking our tasks involved in every project, in every level (software development, meetings, project management, etc.)”",
      name: "— Maria Lucia S.",
    },
    {
      id:3,
      text: "“Everhour helps me manage/plan my weekly activities a lot more effectively, since I know how much time I have to work on things each day, and can quickly update estimated times to reallocate tasks as needed.”",
      name: "— Dan S.",
    },
    {
      id:4,
      text: "“We are using Everhour as a core business software, because our business is to sell our time. When you use such software, what you care about the most is speed, flexibility, ability to integrate with all major project management software. And Everhour is exactly that kind of software”",
      name: "— Ivan M.",
    },
    {
      id:5,
      text: "“We are a 15 people team working remotely from different cities of Latin America and Europe, and time tracking for each client, project, and task has always been a major issue. We’ve been using Everhour for the past year or so, and it has become an essential tool for our team. It does not only give us the ability to track how much time we have dedicated to a project but also to estimate how much time a particular task will need in order to be completed next time and by who. Easily create and save reports with just a few clicks”",
      name: "— Daniel Y.",
    },
    {
      id:6,
      text: "“The most important gain from using Everhour is that we can track our tasks in real-time without having to leave the browser. The Chrome add-on helps us initiate the time for a specific task. If we are already on Asana, a simple click does the job.”",
      name: "— Dimitris R.",
    },
    {
      id:7,
      text: "“Everhour’s integration with Asana is wonderful for a remote team. We track all activities in Asana, but before Everhour I often wondered how long it was taking to do a task, now I know exactly. I can see who is working right now and a summary each day”.",
      name: "— Doug H.",
    },
    {
      id:8,
      text: "“Everhour has already paid for itself for the year by helping me track time I was missing in client projects. It is easy to use, has friendly customer service people, and the reports make it easy to invoice clients and track projects.”",
      name: "— Jennifer D.",
    },
  ];